"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var StudentClassesController = /** @class */ (function () {
    function StudentClassesController(student, UsersModel, CoursesModel, FlashService, $window, coursesPolicy) {
        var _this = this;
        this.signingClass = null;
        this.loading = false;
        this.classes = [];
        this.student = student;
        this.UsersModel = UsersModel;
        this.CoursesModel = CoursesModel;
        this.FlashService = FlashService;
        this.$window = $window;
        this.UsersModel.getStudentClasses(this.student.id, null).then(function (response) {
            _this.classes = response.classes;
        });
        this.cancel = this.cancel.bind(this);
        this.classIsInPast = this.classIsInPast.bind(this);
        this.saveSignature = this.saveSignature.bind(this);
        this.coursesPolicy = coursesPolicy;
    }
    StudentClassesController.prototype.canCancel = function () {
        return (this.coursesPolicy.getMetaValueByKey("allow_student_to_cancel_classes") === "Y");
    };
    StudentClassesController.prototype.signatureRequired = function () {
        return (this.coursesPolicy.getMetaValueByKey("require_student_signature_on_class_attendance") === "Y");
    };
    /**
     * Whether to offer sign-in for a class: the school collects attendance
     * signatures, the class has started, and one hasn't been collected yet.
     */
    StudentClassesController.prototype.canSignIn = function (classDate) {
        return (this.signatureRequired() &&
            (0, time_1.isBefore)((0, time_1.dateTimeStringToDate)(classDate.start), new Date()) &&
            !classDate.signed);
    };
    StudentClassesController.prototype.startSigning = function (classDate) {
        this.signingClass = classDate;
    };
    StudentClassesController.prototype.saveSignature = function (signature) {
        var _this = this;
        var classDate = this.signingClass;
        if (classDate === null) {
            return;
        }
        this.CoursesModel.submitClassSignature({
            course_id: classDate.course_id,
            class_id: classDate.id,
            signature_data: signature,
        }).then(function (response) {
            classDate.signed = true;
            _this.signingClass = null;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        }, function () {
            _this.FlashService.setMessage({
                type: "danger",
                message: "There was a problem saving your signature.",
            });
        });
    };
    StudentClassesController.prototype.classIsInPast = function (classDate) {
        return (0, time_1.isBefore)((0, time_1.dateTimeStringToDate)(classDate.start), new Date());
    };
    StudentClassesController.prototype.cancel = function (class_id) {
        var _this = this;
        var confirm = this.$window.confirm("Are you sure you want to cancel this class?");
        if (confirm === false) {
            return false;
        }
        this.UsersModel.cancelStudentClass(this.student.id, class_id)
            .then(function (response) {
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.classes = _this.classes.filter(function (class_date) {
                return class_date.id !== class_id;
            });
        })
            .catch(function (Error) {
            console.error(Error);
        });
    };
    return StudentClassesController;
}());
StudentClassesController.$inject = [
    "student",
    "UsersModel",
    "CoursesModel",
    "FlashService",
    "$window",
    "coursesPolicy",
];
exports.default = StudentClassesController;
